import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Chip,
  Container,
  IconButton,
  InputBase,
  TextField,
  Typography,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import BuzzTabs from '../../../components/BuzzTab/BuzzTabs';
import BuzzTab from '../../../components/BuzzTab/BuzzTab';
import { useRouteQuery } from '../../../hooks/useRouteQuery';
import { BLOG_POST, IMAGE_POST } from './constant';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import PostAddIcon from '@material-ui/icons/PostAdd';
import SvgPlusCircle from '../../../assets/SvgPlusCircle';
import { useFormik } from 'formik';
import CancelIcon from '@material-ui/icons/Cancel';
import { GenericSnackBarContext } from '../../../components/context/GenericSnakBarContextProvider';
import { CITY } from '../../../utils/enum';
import { GenericModalContext } from '../../../components/context/GenericModalContextProvider';
import BuzzImage from '../../../components/BuzzImage/BuzzImage';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link,
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom';
import { uploadFileSchoolWebAsync } from '../../common/CommonStore/CommonStoreSlice';
import { updateStoryAsync } from '../ApprovalStore/approvalSlice';

const articleMaxLength = 150;
const blogMaxLength = 500;

const hashTags = [
  'School Life',
  'Parenting',
  'Self Study',
  'Exams',
  'Extra Crriculum',
  'Sports',
  'Annual Day',
  'Achievement',
  'Celebration',
];

const useStyles = makeStyles((theme) => ({
  containerStyle: {
    maxWidth: theme.props.buzzContainerWidth,
    backgroundColor: 'white',
    borderRadius: theme.props.buzzBorderRadius,
    marginBottom: theme.spacing(5),
  },
  containerBoxSyle: {
    maxWidth: 768,
  },
  labelContainer: {
    width: 'auto',
    padding: 0,
  },
  iconLabelWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconMarginRight: {
    marginRight: theme.spacing(1),
  },
  fileUploadBox: {
    minHeight: 275,
  },
  uploadLabelStyle: {
    height: '100%',
    width: '100%',
    borderRadius: 4,
    display: 'block',
    cursor: 'pointer',
  },
  requiredColor: {
    color: theme.palette.error.main,
  },
  imageStyle: {
    objectFit: 'scale-down',
    maxHeight: 250,
  },
  imagePaperBoxStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 10,
    borderColor: theme.palette.buzzBorder,
    position: 'relative',
  },
  removeImageStyle: {
    position: 'absolute',
    top: -25,
    right: -25,
  },
}));

const RequiredTextComponent = ({ text, helperMsg = '' }) => {
  const classes = useStyles();
  return (
    <>
      <Box display="flex">
        <Typography>{text}</Typography>
        <Typography className={classes.requiredColor}>*</Typography>
      </Box>
      {helperMsg && helperMsg !== '' && (
        <Box fontFamily="Rubik" fontSize={14}>
          {helperMsg}
        </Box>
      )}
    </>
  );
};

function UpdateStory() {
  const classes = useStyles();
  const theme = useTheme();
  const query = useRouteQuery();

  const [hideBlog, setHideBlog] = useState(false);
  const [hideImage, setHideImage] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const queryEdit = query.get('edit') === 'true';
  const articleType = query.get('type');
  const { SuccessToast, ErrorToast } = useContext(GenericSnackBarContext);

  const { allEditorialStory } = useSelector(({ approvalReducer }) => {
    return {
      allEditorialStory: approvalReducer.editorialStory,
    };
  });

  const location = useLocation();
  const storyId = location && location.search.split('=');

  const storyDetails =
    allEditorialStory &&
    allEditorialStory.data &&
    allEditorialStory.data.find((item) => item._id === storyId[1]);

  const [activeTab, setActiveTab] = useState(storyDetails && storyDetails.type);

  useEffect(() => {
    if (articleType === BLOG_POST) {
      setActiveTab(BLOG_POST);
      setHideImage(true);
    } else if (articleType === IMAGE_POST) {
      setActiveTab(IMAGE_POST);
      setHideBlog(true);
    }
  }, [articleType]);

  const inputBoxHeight = activeTab === IMAGE_POST ? 218 : 218;
  const addLabel =
    activeTab === IMAGE_POST ? 'Add Image Title' : 'Add Blog Title';
  const imageLabelText =
    activeTab === IMAGE_POST ? 'Add a image' : 'Add a cover image';
  const inputLabelText =
    activeTab === IMAGE_POST
      ? 'Add a caption/description to go with the image'
      : 'write your blog';

  const genericCreateEditStoryDispatcher = (asyncFn) => (payload) =>
    dispatch(asyncFn(payload))
      .unwrap()
      .then(() => {
        handleLoader(false);
        if (queryEdit) SuccessToast('Story editted successfully');
        else SuccessToast('Story updated successfully');
        history.push('/approval-management/story-approval');
      })
      .catch(() => {
        handleLoader(false);
        ErrorToast('Please fill all the fields');
        handleLoader(false);
      });

  const handleUpdateStory = genericCreateEditStoryDispatcher(updateStoryAsync);

  const formik = useFormik({
    initialValues: {
      hashTags:
        storyDetails && storyDetails.hashTags
          ? storyDetails && storyDetails.hashTags
          : '',
      title:
        storyDetails && storyDetails.title
          ? storyDetails && storyDetails.title
          : '',
      article:
        storyDetails && storyDetails.article
          ? storyDetails && storyDetails.article
          : '',
      typeOfArticle:
        storyDetails && storyDetails.type
          ? storyDetails && storyDetails.type
          : '',
      files:
        storyDetails && storyDetails.imageLink
          ? storyDetails && storyDetails.imageLink
          : [],
      imgUrls:
        storyDetails && storyDetails.imageFullUrls
          ? storyDetails && storyDetails.imageFullUrls
          : [],
    },

    onSubmit: (values) => {
      handleLoader(true);
      const { hashTags, title, article, files } = values;

      let body = {
        title,
        type: activeTab,
        article,
        city: CITY,
        imageLink: files,
        hashTags: hashTags,
      };
      if (files.length > 0) {
        if (storyId && storyId) {
          body._id = storyId[1];
          handleUpdateStory(body);
        }
      } else {
        ErrorToast('Image is required!');
        handleLoader(false);
      }
    },
  });

  const handleHashTag = (val) => {
    const { hashTags } = formik.values;
    if (!hashTags.includes(val)) {
      formik.setFieldValue('hashTags', [...hashTags, val]);
    } else {
      formik.setFieldValue(
        'hashTags',
        hashTags.filter((item) => item !== val)
      );
    }
  };

  const articleWordCount = (article) => {
    const words = article.split(' ');
    return article === '' ? 0 : words.length;
  };

  const { handleLoader } = useContext(GenericModalContext);

  const handleFileSelect = (event) => {
    dispatch(uploadFileSchoolWebAsync({ file: event.target.files[0] }))
      .unwrap()
      .then((res) => {
        if (res && res.data && res.data.document) {
          formik.setFieldValue('files', [
            ...formik.values.files,
            res.data.document,
          ]);
          formik.setFieldValue('imgUrls', [
            ...formik.values.imgUrls,
            res.urls[0],
          ]);
        }
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };

  const removeFromFile = (id) => {
    const updatedFiles =
      formik &&
      formik.values &&
      formik.values.files.filter((file) => file !== id);
    formik.setFieldValue('files', updatedFiles);
  };

  const noOfImages = formik.values.files.length;

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
    formik.setFieldValue('typeOfArticle', newValue);
  };

  const handleArticleChange = (e) => {
    const val = e.target.value;
    if (activeTab === IMAGE_POST) {
      if (articleWordCount(val) <= articleMaxLength) {
        formik.handleChange('article')(e.target.value);
      }
    } else {
      if (articleWordCount(val) <= blogMaxLength) {
        formik.handleChange('article')(e.target.value);
      }
    }
  };

  return (
    <Container className={classes.containerStyle}>
      <Box m={'auto'} className={classes.containerBoxSyle}>
        <Link
          to="/approval-management/story-approval"
          style={{ textDecoration: 'none', color: 'black' }}>
          <Box display="flex" alignItems="center">
            <IconButton>
              <ArrowBackIcon />
            </IconButton>
            <Typography>Back</Typography>
          </Box>
        </Link>
        <Typography variant="h4" component="div">
          <Box fontWeight="fontWeightMedium">Update Story</Box>
        </Typography>
        <Box
          mt={3}
          border={1}
          borderRadius={4}
          borderColor={theme.palette.buzzBorder}>
          <BuzzTabs
            value={activeTab}
            onChange={handleChange}
            aria-label="story tabs">
            <Box ml={3} />
            {!hideImage && (
              <BuzzTab
                classes={{
                  wrapper: classes.iconLabelWrapper,
                  labelContainer: classes.labelContainer,
                }}
                label="Image Post"
                icon={<CropOriginalIcon className={classes.iconMarginRight} />}
                value={IMAGE_POST}
              />
            )}
            {!hideBlog && (
              <BuzzTab
                classes={{
                  wrapper: classes.iconLabelWrapper,
                  labelContainer: classes.labelContainer,
                }}
                label="Blog Post"
                value={BLOG_POST}
                icon={<PostAddIcon className={classes.iconMarginRight} />}
              />
            )}
          </BuzzTabs>
          <Box p={3} flex={1}>
            <RequiredTextComponent text={addLabel} />
            <Box my={1.5}>
              <TextField
                placeholder="title"
                fullWidth
                variant="outlined"
                name="title"
                value={formik.values.title}
                onChange={formik.handleChange}
              />
            </Box>
            <input
              type="file"
              hidden
              id="raised-button-file"
              accept=".jpg,.jpeg,.png"
              onChange={handleFileSelect}
            />
            <Box mb={1}>
              <RequiredTextComponent
                text={imageLabelText}
                helperMsg="Image file must be less than 2 MB."
              />
            </Box>
            <Box
              borderRadius={4}
              borderColor={theme.palette.buzzBorder}
              border={1}
              display="flex"
              flex={1}
              flexWrap={'wrap'}
              className={classes.fileUploadBox}>
              {formik.values.files &&
                formik.values.files.map((file) => (
                  <Box
                    border={1}
                    p={0.5}
                    m={1}
                    borderRadius={4}
                    key={file}
                    className={classes.imagePaperBoxStyle}>
                    <Box
                      borderRadius={4}
                      display="flex"
                      flex={1}
                      alignItems={'center'}>
                      <BuzzImage
                        className={classes.imageStyle}
                        src={file}
                        alt="uploaded"
                      />
                      <IconButton
                        onClick={() => {
                          removeFromFile(file);
                        }}
                        className={classes.removeImageStyle}
                        color="primary">
                        <CancelIcon color="action" />
                      </IconButton>
                    </Box>
                  </Box>
                ))}

              {noOfImages < 3 && (
                <Box flex={1}>
                  <label
                    htmlFor="raised-button-file"
                    d
                    className={classes.uploadLabelStyle}>
                    <Box
                      border={1}
                      style={{ background: theme.palette.buzzFadeLite }}
                      borderRadius={4}
                      borderColor={theme.palette.buzzBorder}
                      display="flex"
                      flex={1}
                      flexGrow={1}
                      height={275}
                      alignItems="center"
                      justifyContent="center">
                      <SvgPlusCircle />
                    </Box>
                  </label>
                </Box>
              )}
            </Box>

            <Box mt={3} mb={1} display="flex">
              <Box flexGrow={1}>
                <RequiredTextComponent text={inputLabelText} />
              </Box>
              <Typography color="textSecondary">
                {activeTab === IMAGE_POST
                  ? `${articleWordCount(
                      formik.values.article
                    )}/${articleMaxLength}`
                  : `${articleWordCount(
                      formik.values.article
                    )}/${blogMaxLength}`}
              </Typography>
            </Box>
            <Box
              flex={1}
              border={1}
              height={inputBoxHeight}
              p={2}
              borderRadius={4}
              borderColor={theme.palette.buzzBorder}>
              <InputBase
                multiline={true}
                rows={12}
                style={{ width: '100%' }}
                height={218}
                placeholder="Enter your text here"
                value={formik.values.article}
                onChange={handleArticleChange}
              />
            </Box>

            <Box flex={1}>
              <Box mt={3} mb={1}>
                <RequiredTextComponent text="Select 3 keywords that suit your post (helps in search results)" />
              </Box>
              <Box display="flex" flexWrap="wrap" flex={1}>
                {hashTags.map((option) => (
                  <Box mx={0.5} my={0.5} key={option}>
                    <Chip
                      label={option}
                      variant="outlined"
                      onClick={() => handleHashTag(option)}
                      color={
                        formik.values.hashTags.includes(option)
                          ? 'primary'
                          : 'default'
                      }
                      clickable
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box flex={1} display="flex" my={3}>
          <Box flex={1} flexGrow={1} />
          <Button
            variant="contained"
            color="primary"
            onClick={formik.handleSubmit}>
            Post story
          </Button>
        </Box>
      </Box>
    </Container>
  );
}

export default UpdateStory;
